import Link from "components/link";
import * as React from 'react';
export default {
  Link,
  React
};